import Axios from "axios";

const gameTypes = {
    namespaced: true,
    state: {
        list: [],
        loaded: false,
        promise: null,
    },
    actions: {
        async loadList ({ state, commit }) {
            if (state.promise) {
                return state.promise;
            }

            let promise = Axios({
                url: '/api/v1/game-types',
                method: 'GET',
            }).then(resp => {
                commit('SET_LIST', resp.data);
                commit('SET_LOADED', true);
            }).finally(() => {
                commit('SET_PROMISE', null);
            })

            commit('SET_PROMISE', promise);

            return promise;
        },
    },
    mutations: {
        SET_LIST: (state, payload) => {
            state.list = payload;
        },
        SET_LOADED: (state, payload) => {
            state.loaded = payload;
        },
        SET_PROMISE: (state, payload) => {
            state.promise = payload;
        },
    },
    getters: {
        getName: (state) => id => {
            let gameType = state.list.find(item => item.id === id);
            return gameType ? gameType.name : id
        },
        get: (state) => id => state.list.find(item => item.id === id),
        list: (state) => state.list,
        loaded: (state) => state.loaded,
    }
};

export default gameTypes;
